export function formatSuccessRate(value: number): string {
  let formatted = value.toFixed(2);
  if (formatted === '100.00' && value !== 100) {
    formatted = value.toFixed(4);
  } else if (formatted === '0.00' && value !== 0) {
    formatted = value.toFixed(4);
  }
  return formatted;
}
